import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Auth0Provider } from "@auth0/auth0-react";
import { ThemeProvider } from "next-themes";
import { env } from "./lib/env";

const root = createRoot(document.getElementById("root")!);

root.render(
  <StrictMode>
    <ThemeProvider 
      attribute="class" 
      defaultTheme="system" 
      enableSystem
      disableTransitionOnChange={false}
    >
      <Auth0Provider
        domain={env.AUTH0_DOMAIN}
        clientId={env.AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: env.AUTH0_REDIRECT_URI,
          audience: env.AUTH0_AUDIENCE,
          scope: "openid profile email",
        }}
      >
        <App />
      </Auth0Provider>
    </ThemeProvider>
  </StrictMode>
);
